import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { NotificationBellMenu } from '@mlm/ui';
import {
  getUnreadCount,
  listNotifications,
  markAllNotificationsRead,
  markNotificationRead,
} from '../../lib/api';

/**
 * Admin bell (LMS Phase 2 — it replaced a decorative placeholder).
 *
 * Shows the SIGNED-IN admin's own rows. Owner alerts (`notifyOwners`) fan out
 * to super_admins PLUS everyone whose role holds the alert's own permission,
 * so the built-in `admin` role — which holds all of them — sees them here too.
 */
export function NotificationsBell() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const unreadQ = useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: getUnreadCount,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
  const recentQ = useQuery({
    queryKey: ['notifications', 'recent'],
    queryFn: () => listNotifications({ limit: 10 }),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  const markAll = useMutation({
    mutationFn: markAllNotificationsRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
  const markOne = useMutation({
    mutationFn: markNotificationRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });

  return (
    <NotificationBellMenu
      items={recentQ.data?.items ?? []}
      unreadCount={unreadQ.data?.count ?? 0}
      onMarkRead={(id) => markOne.mutate(id)}
      onMarkAll={() => markAll.mutate()}
      markAllPending={markAll.isPending}
      onOpen={(path) => navigate(path)}
      seeAllHref="/notifications"
      iconClassName="h-5 w-5"
    />
  );
}
